import SEO from "@/components/SEO";

/**
 * <NoIndex />: drop into any private/authenticated layout so search
 * engines (and indirectly social crawlers) never index dashboards or
 * the bare login/register/billing surfaces.
 *
 * Sets noindex/nofollow regardless of the runtime host, since these
 * pages are NEVER appropriate for indexing, even on the production
 * domain.
 */
export default function NoIndex({ title = "ConfirmPH", description }) {
  return (
    <SEO
      noindex
      title={title}
      description={description}
      // No canonical: we don't want crawlers building any picture of
      // private dashboards from cached responses.
      canonical={null}
    />
  );
}
